import {
	IPostback,
	IPostbackTest,
	TCreatePostbackRequest,
	TPostbackList,
	TUpdatePostbackRequest,
} from 'entities/Postback';
import { commonApi } from 'shared/api/commonApi';
import { EApiTags } from 'shared/typings/enums/apiTags.enum';
import { getCookie } from 'shared/utils/getCookie';

export const postbackApi = commonApi
	.injectEndpoints({
		endpoints: (builder) => ({
			getPostback: builder.query<IPostback, string>({
				query: (uuid) => ({
					url: `opt_codes/${uuid}/`,
				}),
			}),
			getPostbackList: builder.query<TPostbackList, string>({
				query: (params) => ({
					url: `opt_codes/${params ? '?' : ''}${params}`,
				}),
			}),
			addPostback: builder.mutation<IPostback, TCreatePostbackRequest>({
				query(body) {
					return {
						url: `opt_codes/`,
						headers: { 'X-Csrftoken': getCookie('csrftoken') },
						method: 'POST',
						body,
					};
				},
			}),
			updatePostback: builder.mutation<IPostback, TUpdatePostbackRequest>({
				query({ uuid, ...body }) {
					return {
						url: `opt_codes/${uuid}/`,
						headers: { 'X-Csrftoken': getCookie('csrftoken') },
						method: 'PUT',
						body,
					};
				},
			}),
			deletePostback: builder.mutation<TUpdatePostbackRequest, string>({
				query(uuid) {
					return {
						url: `opt_codes/${uuid}/`,
						headers: { 'X-Csrftoken': getCookie('csrftoken') },
						method: 'DELETE',
					};
				},
			}),
			testPostback: builder.mutation<IPostbackTest, string>({
				query(uuid) {
					return {
						url: `opt_codes/${uuid}/test/`,
						headers: { 'X-Csrftoken': getCookie('csrftoken') },
						method: 'POST',
					};
				},
			}),
		}),
		overrideExisting: false,
	})
	.enhanceEndpoints({
		addTagTypes: [EApiTags.POSTBACKS_LIST, EApiTags.SINGLE_POSTBACK],
		endpoints: {
			getPostback: {
				providesTags: [EApiTags.SINGLE_POSTBACK],
			},
			getPostbackList: {
				providesTags: [EApiTags.POSTBACKS_LIST],
			},
			addPostback: {
				invalidatesTags: [EApiTags.POSTBACKS_LIST],
			},
			updatePostback: {
				invalidatesTags: [EApiTags.POSTBACKS_LIST, EApiTags.SINGLE_POSTBACK],
			},
			deletePostback: {
				invalidatesTags: [EApiTags.POSTBACKS_LIST, EApiTags.SINGLE_POSTBACK],
			},
		},
	});

export const {
	useGetPostbackQuery,
	useGetPostbackListQuery,
	useAddPostbackMutation,
	useUpdatePostbackMutation,
	useDeletePostbackMutation,
	useTestPostbackMutation,
} = postbackApi;
